import React, { useEffect, useState, ReactNode } from "react";
import { Text, Box } from "@mantine/core";
import { wrap } from "framer-motion";

const DynamicText = ({
  children,
  style,
}: {
  children: ReactNode;
  style?: any;
}) => {
  const FONT_SCALE = 0.001;
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const { fontSize, width, textAlign } = style;
  const fontSize_ = (fontSize || 40) * windowWidth * FONT_SCALE;

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Box
      style={{
        display: "flex",
        width: width || "100%",
        justifyContent: "center",
        alignItems: "center",
        ...style,
      }}
    >
      <Text
        style={{
          margin: 0,
          display: "flex",
          fontSize: fontSize_,
          wrap,
          textAlign,
        }}
      >
        {children}
      </Text>
    </Box>
  );
};

export default DynamicText;
